import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { switchMap, map, catchError } from 'rxjs/operators';
import {
  AssignmentGroupsActions,
  LoadAssignmentGroupsSuccess,
  LoadAssignmentGroupsFail,
  SaveAssignmentGroup,
  SaveAssignmentGroupSuccess,
  SaveAssignmentGroupFail,
  DeleteAssignmentGroup,
  DeleteAssignmentGroupSuccess,
  DeleteAssignmentGroupFail
} from './actions';
import { AssignmentGroup } from '../../types/assignments.types';
import { AssignmentGroupsService } from '../../services/assignment-groups.service';
import { of } from 'rxjs';

@Injectable()
export class AssignmentGroupsEffects {
  
  public loadGroups$ = createEffect(() => this.actions$.pipe(
    ofType(AssignmentGroupsActions.Load),
    switchMap(() =>
      this.assignmentGroupsService.getGroups().pipe(
        map((ag: AssignmentGroup[]) => new LoadAssignmentGroupsSuccess(ag)),
        catchError(e => of(new LoadAssignmentGroupsFail(e)))
      )
    )
  ));

  
  public saveGroups$ = createEffect(() => this.actions$.pipe(
    ofType(AssignmentGroupsActions.Save),
    switchMap((action: SaveAssignmentGroup) =>
      this.assignmentGroupsService.saveGroup(action.payload).pipe(
        map(res => new SaveAssignmentGroupSuccess(res)),
        catchError(e => of(new SaveAssignmentGroupFail(e)))
      )
    )
  ));

  
  public deleteGroups$ = createEffect(() => this.actions$.pipe(
    ofType(AssignmentGroupsActions.Delete),
    switchMap((action: DeleteAssignmentGroup) =>
      this.assignmentGroupsService.deleteGroup(action.payload).pipe(
        map(() => new DeleteAssignmentGroupSuccess()),
        catchError(e => of(new DeleteAssignmentGroupFail(e)))
      )
    )
  ));

  constructor(
    private actions$: Actions,
    private assignmentGroupsService: AssignmentGroupsService
  ) {}
}
